export class SelectionData {

    public isSelectable: boolean;
    public isSelected: boolean;
    public isMandatory: boolean;

    constructor(selectionData: any = {}) {
        this.isSelectable = selectionData.isSelectable || false;
        this.isSelected = selectionData.isSelected || false;
        this.isMandatory = selectionData.isMandatory || false;
    }

    get type() {
        return 'selectionData';
    }

}
